export function getW2Year() {
  const now = new Date()
  const currentYear = now.getFullYear()
  const currentMonth = now.getMonth()
  const w2Year = currentMonth <= 2 ? currentYear - 2 : currentYear - 1

  return {
    currentYear,
    w2Year,
  }
}
